import { useIntl } from 'react-intl'
import { FilterRowLabels } from './filter-drawer'

/**
 * The app-side companion to the row's English defaults: the full label set translated through
 * react-intl. Lives in its own file so the components themselves keep zero i18n dependency.
 */
export function useFilterRowLabels(): FilterRowLabels {
  const { formatMessage } = useIntl()
  return {
    filters: formatMessage({ id: 'app.filters' }),
    more: formatMessage({ id: 'app.more' }),
    clearAll: formatMessage({ id: 'app.clearFilters' }),
    apply: formatMessage({ id: 'app.apply' }),
    // FilterDrawer interpolates {count} itself via replace(), so the placeholder must survive
    // formatMessage - re-inserting it as the value keeps it literal.
    showResults: formatMessage({ id: 'components.filterRow.showResults' }, { count: '{count}' }) as string,
    discardTitle: formatMessage({ id: 'components.filterRow.discardTitle' }),
    discardBody: formatMessage({ id: 'components.filterRow.discardBody' }),
    discardConfirm: formatMessage({ id: 'components.filterRow.discardConfirm' }),
    keepEditing: formatMessage({ id: 'components.filterRow.keepEditing' }),
    noOptions: formatMessage({ id: 'components.filterRow.noOptions' }),
    search: formatMessage({ id: 'components.filterRow.search' }),
    noResults: formatMessage({ id: 'components.filterRow.noResults' }, { query: '{query}' }) as string,
    // The trigger fills {group} itself, so the placeholder has to survive formatMessage.
    expandGroup: formatMessage({ id: 'components.filterRow.expandGroup' }, { group: '{group}' }) as string,
    collapseGroup: formatMessage({ id: 'components.filterRow.collapseGroup' }, { group: '{group}' }) as string,
  }
}
